import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { localizePath, switchLanguagePath } from "@/i18n/translations";

export const MainNavbar = ({ lang, labels, isAuthenticated, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const nextLang = lang === "ar" ? "en" : "ar";
  const branchesPath = localizePath(lang, "/branches");

  return (
    <nav
      className="pointer-events-none fixed left-0 right-0 top-0 z-50 px-4 py-2 sm:px-10 sm:py-4"
      data-testid="main-navbar"
    >
      <div
        className="pointer-events-none mx-auto flex w-full max-w-7xl items-center justify-between rounded-full border border-white/30 bg-white/15 px-4 py-3 shadow-xl backdrop-blur-xl sm:px-7"
        data-testid="main-navbar-container"
      >
        <Link
          className="brand-gradient pointer-events-auto rounded-full border border-white/35 bg-black/45 px-3 py-1 text-base font-semibold drop-shadow-sm sm:text-lg"
          to={localizePath(lang)}
          data-testid="main-navbar-brand-link"
        >
          {labels.brand}
        </Link>

        <div className="flex items-center gap-2 sm:gap-3" data-testid="main-navbar-actions">
          <Link to={localizePath(lang)} className="pointer-events-auto" data-testid="main-navbar-home-link">
            <Button variant="ghost" className="pointer-events-auto rounded-full text-xs sm:text-sm" data-testid="main-navbar-home-button">
              {labels.home}
            </Button>
          </Link>

          <Link to={branchesPath} className="pointer-events-auto" data-testid="main-navbar-branches-link">
            <Button variant="ghost" className="pointer-events-auto rounded-full text-xs sm:text-sm" data-testid="main-navbar-branches-button">
              {labels.branches}
            </Button>
          </Link>

          {isAuthenticated && (
            <>
              <Link to={localizePath(lang, "/dashboard")} className="pointer-events-auto" data-testid="main-navbar-dashboard-link">
                <Button variant="ghost" className="pointer-events-auto rounded-full text-xs sm:text-sm" data-testid="main-navbar-dashboard-button">
                  {labels.dashboard}
                </Button>
              </Link>
              <Button
                variant="outline"
                className="pointer-events-auto rounded-full border-gold-500/40 text-xs sm:text-sm"
                onClick={onLogout}
                data-testid="main-navbar-logout-button"
              >
                {labels.logout}
              </Button>
            </>
          )}

          <Button
            variant="outline"
            className="pointer-events-auto rounded-full border-gold-500/40 bg-white/50 text-xs font-semibold text-stone-800"
            onClick={() => navigate(switchLanguagePath(location.pathname, nextLang))}
            data-testid="main-navbar-language-switch-button"
          >
            {labels.switchTo}
          </Button>
        </div>
      </div>
    </nav>
  );
};
